import { useEffect, useState } from "react";
import { MailCheck, MailX, ChevronDown } from "lucide-react";
import api from "@/lib/api";
import { formatDMYTime } from "@/lib/date";

const Entry = ({ e }) => {
  const [open, setOpen] = useState(false);
  const ok = e.status === "Sent";
  return (
    <li className="py-2" data-testid={`email-log-row-${e.id}`}>
      <button type="button" onClick={() => setOpen((v) => !v)} className="w-full text-left flex items-start gap-2" data-testid={`email-log-toggle-${e.id}`}>
        {ok ? <MailCheck className="w-4 h-4 text-emerald-600 mt-0.5 shrink-0" /> : <MailX className="w-4 h-4 text-rose-600 mt-0.5 shrink-0" />}
        <div className="flex-1 min-w-0">
          <div className="text-sm text-slate-900 truncate">{e.subject}</div>
          <div className="text-[11px] text-slate-500">{ok ? "Sent" : "Failed"} · {formatDMYTime(e.at)} · {e.sent_by?.name || e.sent_by?.email}</div>
        </div>
        <ChevronDown className={`w-4 h-4 text-slate-400 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="mt-2 ml-6 text-xs text-slate-600 space-y-1" data-testid={`email-log-detail-${e.id}`}>
          <div><b>Version:</b> {e.display_number}</div>
          <div><b>To:</b> {e.to.join(", ")}</div>
          {e.cc?.length > 0 && <div><b>CC:</b> {e.cc.join(", ")}</div>}
          <div><b>Attachment:</b> {e.attachment}</div>
          {ok ? <div className="break-all"><b>Provider ID:</b> {e.provider_id}</div> : <div className="text-rose-600"><b>Error:</b> {e.error}</div>}
          <pre className="whitespace-pre-wrap font-sans bg-slate-50 border border-slate-100 rounded p-2 text-slate-800">{e.body_text}</pre>
        </div>
      )}
    </li>
  );
};

export function EmailLogPanel({ quotation }) {
  const [logs, setLogs] = useState([]);
  useEffect(() => {
    api.get(`/quotations/${quotation.id}/email-log`).then((r) => setLogs(r.data)).catch(() => setLogs([]));
  }, [quotation.id, quotation.status]);
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-4" data-testid="email-log-panel">
      <div className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1 flex items-center gap-1.5"><MailCheck className="w-3.5 h-3.5" /> Email log</div>
      {logs.length === 0 ? <div className="text-xs text-slate-400 py-1" data-testid="email-log-empty">No emails sent from the ERP yet.</div> : (
        <ul className="divide-y divide-slate-100">{logs.map((e) => <Entry key={e.id} e={e} />)}</ul>
      )}
    </div>
  );
}
